export default function logoutCleanup() {
  localStorage.removeItem('account');

  window.location = 'logout';
}
